module.exports = __webpack_public_path__ + "static/media/wallpaper.07956028.jpg";